import { utils } from 'apprise-core/utils';
import { ClientConfiguration } from 'apprise-frontend-core/client/config';
import { createProvider } from 'apprise-frontend-core/state/factory';
import { AxiosInstance } from 'axios';


// client-facing config and axios implementation
// ---------------------------------------------------------------------------------

export const [ClientProvider, useClient] = createProvider({

  runtimeId: utils().mint(),

  impl: undefined! as AxiosInstance,

  ... {

    request: {
      timeout: 15000
    }
    ,

    services: {
      domain: { prefix: "/domain" }
    },

    onRequest: [],

    onError: []

  } satisfies ClientConfiguration as ClientConfiguration,

})


// preload
// ---------------------------------------------------------------------------------



// note: we use mutable state so resolved tasks can be removed and won't interfere with data refresh policies.
export const [PreloaderProvider, usePreloaders] = createProvider({
  loaders: {} as Record<string, Promise<any>>
})